module.exports = __webpack_public_path__ + "img/no-image-200px.7c2534d3.png";